import {
	SIMULATION_GOTO_LOCATION_TYPES,
	SIMULATION_RESET_PAGINATION,
	SIMULATION_SET_FIRTPAGE,
	SIMULATION_SET_GENERATED,
	SIMULATION_SET_JSON,
	SIMULATION_SET_LN,
	SIMULATION_SET_LOCATION_TYPES,
	SIMULATION_SET_LTN,
	SIMULATION_SET_PAGINATION_STATE,
	SIMULATION_SET_SN,
	SIMULATION_SET_SURVEY_ANSWERS,
	SIMULATION_SET_SURVEYON,
	SIMULATION_INIT,
	SIMULATION_RESET,
	SIMULATION_SET_EMPLACEMENT_LOCATIONS_TYPES,
	SIMULATION_SET_KPI_PAGE,
} from "./../../types";

import { createReducer } from "./../functions";
import _ from "lodash";

const initialState = {
	isSurveyGenerated: false,
	ltN: 0,
	lN: 0,
	sN: 0,
	//current media page
	mediaPage: -1,
	//currentKpiPage (matrix view)
	kpiPage: 0,
	//locationTypes selection (first page)
	emplacementLocationsTypes: [],
	firstPage: true,
	surveyOn: true,
	surveyAnswers: [],
	locationTypes: [],
	ranges: [],
	products: [],
	json: {
		sectors: [],
		metier: {
			ranges: [],
			products: [],
			locationTypes: [],
		},
		surveyAnswers: [],
		surveyData: {},
		visit: {},
	},
};
const init = {
	[SIMULATION_INIT]: (state, action) => {
		return Object.assign({}, state, ...action.simulationManager);
	},
};
const setJSON = {
	[SIMULATION_SET_JSON]: (state, action) => {
		return Object.assign({}, state, { json: action.json });
	},
};

const setGenerated = {
	[SIMULATION_SET_GENERATED]: (state, action) => {
		return Object.assign({}, state, {
			isSurveyGenerated: action.isSurveyGenerated,
		});
	},
};

const setLTN = {
	[SIMULATION_SET_LTN]: (state, action) => {
		return Object.assign({}, state, { ltN: action.ltN });
	},
};

const setlN = {
	[SIMULATION_SET_LN]: (state, action) => {
		return Object.assign({}, state, { lN: action.lN });
	},
};

const setSN = {
	[SIMULATION_SET_SN]: (state, action) => {
		return Object.assign({}, state, { sN: action.sN });
	},
};

const setFirstPage = {
	[SIMULATION_SET_FIRTPAGE]: (state, action) => {
		return Object.assign({}, state, { firstPage: action.firstPage });
	},
};

const setKpiPage = {
	[SIMULATION_SET_KPI_PAGE]: (state, action) => {
		return Object.assign({}, state, { kpiPage: action.kpiPage });
	},
};

const setSurveyON = {
	[SIMULATION_SET_SURVEYON]: (state, action) => {
		return Object.assign({}, state, { surveyOn: action.surveyOn });
	},
};

const setEmplacementLocationsTypes = {
	[SIMULATION_SET_EMPLACEMENT_LOCATIONS_TYPES]: (state, action) => {
		return Object.assign({}, state, {
			emplacementLocationsTypes: action.locationsTypes,
		});
	},
};

const setSurveyAnswers = {
	[SIMULATION_SET_SURVEY_ANSWERS]: (state, action) => {
		return Object.assign({}, state, {
			surveyAnswers: [...action.surveyAnswers],
		});
	},
};

const setPaginationState = {
	[SIMULATION_SET_PAGINATION_STATE]: (state, action) => {
		return Object.assign({}, state, {
			ltN: action.ltN,
			lN: action.lN,
			sN: action.sN,
			firstPage: action.firstPage,
			mediaPage: action.mediaPage,
			kpiPage: action.kpiPage,
		});
	},
};

const setLocationTypes = {
	[SIMULATION_SET_LOCATION_TYPES]: (state, action) => {
		//disable simulation
		return state;


		const locationTypes = action.locationTypes || [];

		//build surveyAnswers property from locaitonTypes
		let surveyAnswers = state.surveyAnswers || [];
		const pagination = {
			ltN: state.ltN,
			lN: state.lN,
			sN: state.sN,
			firstPage: state.firstPage,
		};

		//Filter locationTypes (remove empty kpis, add/remove statements) and store to simulation
		surveyAnswers.map(surveyAnswer => {
			let locationTypeId = surveyAnswer.locationTypeId;
			const locationTypeIndex = _.findIndex(locationTypes, {
				locationTypeId: locationTypeId,
			});

			let locationType = null;
			if (locationTypeIndex !== -1) {
				locationType = locationTypes[locationTypeIndex];
			}

			const surveyAnswersLocations = surveyAnswer.locations || [];

			surveyAnswersLocations.map((surveyAnswerLocation, index) => {
				if (!locationType) return;
				//statements from form
				const locationTypeStatements = locationType.statements || [];
				const surveyAnswerLocationStatements = [];

				const previousStatements = _.cloneDeep(surveyAnswerLocation.statements);

				locationTypeStatements.map(locationTypeStatement => {
					const locationTypeStatementKpis = locationTypeStatement.kpis || [];
					if (locationTypeStatementKpis.length > 0) {
						//Inject response from simulation
						const previousStatement = _.find(previousStatements, {
							statementId: locationTypeStatement.statementId,
						});
						if (previousStatement) {
							const previousStatementKpis = previousStatement.kpis || [];
							const currentStatementKpis = locationTypeStatement.kpis || [];
							for (let i = 0; i < currentStatementKpis.length; i++) {
								const currentStatementKpi = currentStatementKpis[i];
								const previousStatementKpi =
									_.find(previousStatementKpis, {
										id: currentStatementKpi.id,
									}) || {};
								currentStatementKpi.response =
									previousStatementKpi.response || {};
							}
						}

						surveyAnswerLocationStatements.push(locationTypeStatement);
					}
				});
				//new statements
				//const locationStatements = [];
				pagination.sN = Math.max(
					0,
					Math.min(surveyAnswerLocationStatements.length - 1, pagination.sN)
				);
				surveyAnswerLocation.statements = [...surveyAnswerLocationStatements];
			});
		});

		return Object.assign({}, state, {
			locationTypes: [...locationTypes],
			surveyAnswers: [...surveyAnswers],
			...pagination,
		});
	},
};

//reset simulation (page, states)
const resetPagination = {
	[SIMULATION_RESET_PAGINATION]: (state, action) => {
		return Object.assign({}, state, {
			isSurveyGenerated: false,
			ltN: 0,
			lN: 0,
			sN: 0,
			firstPage: true,
			surveyOn: true,
			mediaPage: -1,
		});
	},
};

//reset all simulation data (page, states, locationTypes, surveyAnswer)
const reset = {
	[SIMULATION_RESET]: state => {
		return Object.assign({}, state, {
			isSurveyGenerated: false,
			ltN: 0,
			lN: 0,
			sN: 0,
			firstPage: true,
			surveyOn: true,
			surveyAnswers: [],
			locationTypes: [],
			ranges: [],
			products: [],
			mediaPage: -1,
			kpiPage: 0,
			emplacementLocationsTypes: [],
		});
	},
};

//reset simulation (page, states)
const gotoLocationType = {
	[SIMULATION_GOTO_LOCATION_TYPES]: (state, action) => {
		const ltN = action.ltN || 0;
		return Object.assign({}, state, {
			ltN: state.isSurveyGenerated ? ltN : 0,
			lN: 0,
			sN: 0,
			firstPage: (ltN === 0),
			surveyOn: true,
			mediaPage: -1,
			kpiPage: 0,
		});
	},
};

const simulationReducer = createReducer(initialState, {
	...init,
	...setGenerated,
	...setLTN,
	...setlN,
	...setSN,
	...setFirstPage,
	...setSurveyON,
	...setJSON,
	...setSurveyAnswers,
	...setPaginationState,
	...setLocationTypes,
	...resetPagination,
	...reset,
	...gotoLocationType,
	...setEmplacementLocationsTypes,
	...setKpiPage,
});

export default simulationReducer;



// WEBPACK FOOTER //
// src/redux/reducers/surveyReducer/simulationReducer.js